import { pwInput, pwMicroLabel } from "./policyWizardFieldStyles";

/** Notice waiver fields for separation policy workflow steps. */
export default function SeparationWorkflowStepExtras({
  step,
  idx,
  workflowKey,
  darkMode,
  updateWorkflowStep,
}) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-2 pt-2 border-t border-[hsl(var(--ds-border))]/60">
      <label className="flex items-center gap-2 text-xs cursor-pointer">
        <input
          type="checkbox"
          checked={!!step.noticeWaiverAllowed}
          onChange={(e) =>
            updateWorkflowStep(workflowKey, idx, "noticeWaiverAllowed", e.target.checked)
          }
          className="rounded border-[hsl(var(--ds-border))]"
        />
        <span className={darkMode ? "text-[hsl(var(--ds-muted-fg))]" : "text-[hsl(var(--ds-muted-fg))]"}>Notice waiver allowed</span>
      </label>
      <div>
        <label className={pwMicroLabel(darkMode)}>Max waiver (days)</label>
        <input
          type="number"
          min={0}
          disabled={!step.noticeWaiverAllowed}
          value={step.noticeWaiverMaxDays ?? 0}
          onChange={(e) =>
            updateWorkflowStep(workflowKey, idx, "noticeWaiverMaxDays", Number(e.target.value) || 0)
          }
          className={`${pwInput(darkMode)} ${!step.noticeWaiverAllowed ? "opacity-50" : ""}`}
        />
      </div>
    </div>
  );
}

/** Depends-on task selector for separation checklist rows. */
export function SeparationChecklistRowExtras({
  item,
  idx,
  checklistMappings,
  darkMode,
  updateChecklistItem,
}) {
  const peerTasks = checklistMappings.filter((t, i) => i !== idx && t.taskId);
  return (
    <div className="md:col-span-7">
      <label className={pwMicroLabel(darkMode)}>Depends on (task)</label>
      <select
        value={item.dependsOnTaskId || ""}
        onChange={(e) => updateChecklistItem(idx, "dependsOnTaskId", e.target.value)}
        className={pwInput(darkMode)}
      >
        <option value="">— None —</option>
        {peerTasks.map((t) => (
          <option key={t.taskId} value={t.taskId}>
            {t.name?.trim() || `Task ${String(t.taskId).slice(0, 8)}…`}
          </option>
        ))}
      </select>
    </div>
  );
}
